export enum SaleStep {
  Viewing = 'viewing',
  ReturnsAndExchanges = 'returns-and-exchanges',
  Payment = 'payment',
  UpdatePaymentMethods = 'update-payment-methods',
}
